export default function EFHairDryer(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M27.5 5H10V14H27.5C28.3284 14 29 13.3284 29 12.5V6.5C29 5.67157 28.3284 5 27.5 5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25 24.5L25 14L20 14L20 24.5C20 25.8807 21.1193 27 22.5 27C23.8807 27 25 25.8807 25 24.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4 12V7H5.6459C5.87877 7 6.10844 6.94578 6.31672 6.84164L10 5V14L6.31672 12.1584C6.10844 12.0542 5.87877 12 5.6459 12H4Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M20 19H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 22H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
